import DateField from '@pelckmans/elementis/components/date-field';
import { ComponentProps } from 'react';
import { Locale } from 'react-day-picker';
import { fr, nlBE } from 'react-day-picker/locale';
import { useTranslation } from 'react-i18next';
import { getStylePropertyValue } from '../../../../utils/style';

const supportedLanguages = ['nl', 'fr'] as const;
type Language = typeof supportedLanguages[number];

const LOCALE_MAP: Record<Language, Locale> = {
  nl: nlBE,
  fr: fr,
};

function isSupportedLanguage(language: string | undefined): asserts language is Language {
  if (!language || !supportedLanguages.includes(language as Language)) {
    throw new Error(`Unsupported language: ${language}. Supported languages are: ${supportedLanguages.join(', ')}`);
  }
}

export const dateFormatter = Intl.DateTimeFormat('en-GB', {
  day: '2-digit',
  month: '2-digit',
});

type Props = DistributiveOmit<ComponentProps<typeof DateField>, 'locale'>;

export default function LocalizedDateField(props: Props) {
  const {
    i18n: { language },
  } = useTranslation();

  const dateMenuZIndex = getStylePropertyValue('--layout-elevation-menu');

  isSupportedLanguage(language);

  return <DateField {...props} locale={LOCALE_MAP[language]} dateMenuZIndex={Number(dateMenuZIndex)} />;
}
